import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initPolyfills } from './utils/polyfills'
import { ErrorBoundary, installChunkErrorListener } from './components/ErrorBoundary'

// Initialiser les polyfills pour la compatibilité multi-navigateurs
initPolyfills();

// Intercepter les ChunkLoadError (lazy imports apres un redeploy) pour
// declencher un reload automatique au lieu d'afficher une page blanche
installChunkErrorListener();

// Initialize dataLayer pour GTM (chargé de manière différée)
window.dataLayer = window.dataLayer || [];

// Charger le rendu immédiatement sans bloquer
createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

